import React, {useState} from 'react'
import {Helmet} from 'react-helmet'
import {Tooltip} from 'aurorui';
import './style.css';
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function TooltipScreen() {
    const [showDrawer, setShowDrawer] = useState(false);
    const openDrawer = () => {
        console.log("hello")
        setShowDrawer(true);
    }
  return (
    <div className=' screen red-bg'>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Tooltip</title>
        </Helmet>
      <h1 className="component-name">Tooltip</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_drawer'>
            
           <Tooltip
                backgroundColor='transparent'
                anchor='left'
                text='left'
            >
                <p className="tooltip-button">left</p>
            </Tooltip>

            <Tooltip
                backgroundColor='transparent'
                anchor='top'
                text='top'
            >
                <p className="tooltip-button">Top</p>
            </Tooltip>

            <Tooltip
                backgroundColor='transparent'
                anchor='bottom'
                text='bottom'
            >
                <p className="tooltip-button">bottom</p>
            </Tooltip>

            <Tooltip
                backgroundColor='transparent'
                anchor='right'
                text='right'
            >
                <p className="tooltip-button">right</p>
            </Tooltip>

        </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props} />
      </div>
    </div>
  );
}

const props = [
    {
        name: "backgroundColor",
        required: 'true',
        description: "Background color of the tooltip",
        possible_values: " hex rgba rgb values"
    },
    {
        name: "anchor",
        required: 'true',
        description: "position of tooltip",
        possible_values: " 'left' 'right' 'top' 'bottom' "
    },
    {
        name: "text",
        required: 'true',
        description: "text on tooltip",
        possible_values: "string"
    },
    {
        name: "children",
        required: 'true',
        description: "component around which tooltip hovers",
        possible_values: "component"
    },
]

export default ComponentScreen(TooltipScreen);

